/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementErrorCode {
    SURVEY_REPLACEMENT_WIZARD_WRONG_STATE = 'survey_replacement_wizard_wrong_state',
}
